import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';

import GaleriaLatinoVegas from '../../Components/Galerias/LatinoVegas';
import Desktop from '../../Components/Desktop';

import lv1 from '../../Images/Proyectos/lv.png';
import lv2 from '../../Images/Proyectos/Galerias/Latino-Vegas/10.png';



const LatinoVegas = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
      <Fragment>

        <img className="center-img dimensionar-imagen-movil" alt="" src={lv1}></img>

        <div className='container'>
          {window.screen.width >= 993 ? (
            <p className='texto' style={{textAlign:"center"}}>
              Rediseñamos totalmente la página web de esta increíble agencia de tours en Las Vegas, <br />
              Nevada. Dándole una personalidad más limpia, fresca y amigable. <br /><br />
              La agencia nos pidió remodelar por completo su imagen, <br />
              haciéndola mucho más atractiva y sobre todo dar información sin abrumar a los usuarios. <br /><br />
              En la página web puedes ver todos los tours que ofrecen, <br />
              conocer a detalle las paradas y las actividades que incluye tu recorrido <br />
              para que encuentres el que mejor se adapte a tus vacaciones.
            </p>
          ) :(
            <p className='texto' style={{textAlign:"center"}}>
              Rediseñamos totalmente la página web de esta increíble agencia de tours en Las Vegas, 
              Nevada. Dándole una personalidad más limpia, fresca y amigable. <br /><br />
              La agencia nos pidió remodelar por completo su imagen, 
              haciéndola mucho más atractiva y sobre todo dar información sin abrumar a los usuarios. <br /><br />
              En la página web puedes ver todos los tours que ofrecen, 
              conocer a detalle las paradas y las actividades que incluye tu recorrido 
              para que encuentres el que mejor se adapte a tus vacaciones. 
            </p>
          )}
        </div>

        <Desktop images={{desktop: "latinoVegasDesktop", laptop:"latinoVegasLaptop", movil: "latinoVegasMovil"}} />

        <div className='container'>
          <GaleriaLatinoVegas/>
        </div>

        <div className='dimensionar-imagen-lv'>
          <img className="center-img" alt="" src={lv2}></img>
        </div>

        <div style={{display:"flex", justifyContent:"center", marginBottom:"50px"}}>
          <div className='btn_1'>
            <a href="#portafolioSofwareOver" style={{color:"#fff"}}>
              <p>
                Ver más del portafolio
              </p>
            </a>
          </div>
        </div>
        
      </Fragment>
    );
}

export default LatinoVegas;
